import { render, staticRenderFns } from "./seguimento.vue?vue&type=template&id=6c38ff06&scoped=true"
import script from "./seguimento.vue?vue&type=script&lang=js"
export * from "./seguimento.vue?vue&type=script&lang=js"
import style0 from "./seguimento.vue?vue&type=style&index=0&id=6c38ff06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c38ff06",
  null
  
)

export default component.exports